import { render, staticRenderFns } from "./CustomSkinMessage.vue?vue&type=template&id=4132c834&"
import script from "./CustomSkinMessage.vue?vue&type=script&lang=js&"
export * from "./CustomSkinMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports